import { useState, useEffect, useRef } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import Button from '../ui/Button';
import './Header.css';
import config from '../../config';

const Header = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { isAuthenticated, user, profile, hasActiveSubscription, signOut, isSigningOut } = useAuth();
  const isHomePage = location.pathname === '/';
  const [isUserMenuOpen, setIsUserMenuOpen] = useState(false);
  const userMenuRef = useRef(null);

  const handleSignOut = async () => {
    try {
      console.log('Signing out...');
      const result = await signOut();
      console.log('Sign out result:', result);
      navigate('/login');
    } catch (error) {
      console.error('Error signing out:', error);
    }
  };

  const toggleUserMenu = () => {
    setIsUserMenuOpen(!isUserMenuOpen);
  };

  // Close the menu when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (userMenuRef.current && !userMenuRef.current.contains(event.target)) {
        setIsUserMenuOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  return (
    <header className={`header ${isHomePage ? 'header-home' : ''}`}>
      <div className="container">
        <div className="header-content">
          <Link to="/" className="logo">
            <div className="logo-container">
              <div className="logo-icon">
                <span className="logo-icon-text">✍️</span>
              </div>
              <span className="logo-text">Sign in Seconds</span>
            </div>
          </Link>
          
          <nav className="nav">
            <ul className="nav-list">
              {isAuthenticated ? (
                <>
                  <li className="nav-item">
                    <Link to="/dashboard" className="nav-link">
                      Dashboard
                    </Link>
                  </li>
                  <li className="nav-item">
                    <Link to="/upload" className="nav-link">
                      New Document
                    </Link>
                  </li>
                  <li className="nav-item">
                    <span className="nav-link disabled">
                      Generate Contract <span className="coming-soon-badge">Coming Soon</span>
                    </span>
                  </li>
                  <li className={`nav-item user-menu ${isUserMenuOpen ? 'user-menu-active' : ''}`} ref={userMenuRef}>
                    <div className="user-info" onClick={toggleUserMenu}>
                      {hasActiveSubscription && (
                        <span className="subscription-badge">PRO</span>
                      )}
                      <span className="user-name">{profile?.full_name || user?.email}</span>
                    </div>
                    <div className={`dropdown-menu ${isUserMenuOpen ? 'dropdown-menu-active' : ''}`}>
                      <Link to="/dashboard" className="dropdown-item">
                        Dashboard
                      </Link>
                      <Link to="/account" className="dropdown-item">
                        My Account
                      </Link>
                      <Link to="/subscription" className="dropdown-item">
                        {hasActiveSubscription ? 'Manage Subscription' : 'Upgrade to Pro'}
                      </Link>
                      <button 
                        className="sign-out-button"
                        onClick={handleSignOut}
                        disabled={isSigningOut}
                      >
                        {isSigningOut ? 'Signing Out...' : 'Sign Out'}
                      </button>
                    </div>
                  </li>
                </>
              ) : (
                <>
                  <li className="nav-item">
                    <Link to="/login" className="nav-link-button">
                      Sign In
                    </Link>
                  </li>
                  <li className="nav-item">
                    <Link to="/signup" className="nav-button">
                      <button className="button button-primary button-small">Sign Up</button>
                    </Link>
                  </li>
                </>
              )}
            </ul>
          </nav>
        </div>
      </div>
    </header>
  );
}

export default Header;
